import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import HardLink from "@/components/HardLink";
import heroImage from "@/assets/hero-detailing.jpg";

const HeroSection = () => {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Premium detailing producten"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-background/40" />
        <div className="absolute inset-0 bg-glow-gradient opacity-30" />
      </div>

      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 grid-pattern opacity-20" />

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 pt-8 md:pt-12 pb-16 md:pb-0">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-secondary/50 border border-primary/30 rounded-full animate-fade-in">
            <Sparkles className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-primary">Premium Auto & Motor Detailing Products</span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-display font-black leading-tight animate-fade-in" style={{ animationDelay: "0.1s" }}>
            <span className="text-foreground">OUT OF THIS</span>
            <br />
            <span className="text-gradient-green text-glow">WORLD</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto animate-fade-in" style={{ animationDelay: "0.2s" }}>
            Professionele verzorgingsproducten voor auto's en motoren die uw voertuig laten stralen. 
            Geschikt voor alle voertuigtypen - van sportwagen tot superbike.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4 animate-fade-in" style={{ animationDelay: "0.3s" }}>
            <Button variant="hero" size="xl" asChild>
              <HardLink to="/shop">
                Shop Nu
                <ArrowRight className="w-5 h-5 ml-2" />
              </HardLink>
            </Button>
            <Button variant="dark" size="xl" asChild>
              <HardLink to="/shop">Bekijk Collectie</HardLink>
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-4 gap-y-2 md:gap-8 pt-4 md:pt-8 pb-8 md:pb-0 text-muted-foreground animate-fade-in" style={{ animationDelay: "0.4s" }}>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-primary rounded-full animate-pulse" />
              <span className="text-sm">Gratis verzending vanaf €50</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-primary rounded-full animate-pulse" />
              <span className="text-sm">30 dagen retourrecht</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-primary rounded-full animate-pulse" />
              <span className="text-sm">Geschikt voor auto & motor</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden md:flex">
        <div className="w-6 h-10 border-2 border-muted-foreground rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-primary rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
